<template>
  <div class="scan-div">
    <el-card class="scan-box-card">
      <el-row
        :gutter="20"
        type="flex"
      >
        <el-col :span="12" class="labelpadding">
          <el-form class="el-form-scanarea">
            <el-form-item class="scan-label" label="扫描区" label-width="auto">
              <el-input
                class="scanarea-style"
                contenteditable="plaintext-only"
                id="input_scancode_id"
                placeholder="请输入条码"
                v-model="_value"
                autofocus
                ref="code"
                @focus="getInputFocus($event)"
                @blur="lostInputFocus($event)"
                @keyup.enter.native="input_ScanArea_Click($event)"
              >
              </el-input>
            </el-form-item>
            <el-input v-show="false"></el-input>
          </el-form>
        </el-col>
        <el-col :span="9" class="errorlabelpadding">
          <div class="error-message-div">
              <span class="errormsgdiv error-title"><strong>{{ errorTitle }}</strong></span>
              <span :title="errormessage"
                    :class="{ errormsgdiv: true, oversize: checkFontSize(),'size2':size2(),'size3':size3()}">
                <strong>{{ errorContent }}</strong></span>
          </div>
        </el-col>
        <el-col :span="3" class="package_img" v-if="ShowPic">
          <img id="dashboardModel.captureimage" style="width: 100%;height: 100%" src="../../../../public/img/1.png"/>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
  import DeviceStatus from "@/views/components/DeviceStatus/deviceStatus";
  import Enumerable from "linq";
  import {getStrLen} from "@/utils";
  import { SystemConfigModule } from "@/store/modules/store_systemconfig";

  export default {
    props: ["value", "errormessage", 'ShowDevice', 'ShowPic'],
    name: "Scan2",
    components: {DeviceStatus},
    watch: {
      deviceItems: {
        handler(newone, oldone) {
          if (newone != null && newone.length > 0) {
            this.deviceStateLabelVisible = true;
          } else {
          }
        }
      }
    },

    mounted() {
      // for (let i = 0; i < 12; i++) {
      //   this.deviceItems.push({
      //     title: "无数据",
      //     status: "defult",
      //     name: "设备" + (i + 1),
      //   });
      // }
    },
    computed: {
      _value: {
        get() {
          return this.value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\ ]/g, '').toUpperCase();
        },
        set(val) {
          this.$emit("input", val);
        }
      },
      myDeviceItems: function () {
        console.log('myDeviceItems');
        if (this.deviceItems.length) {
          return this.deviceItems;
        }
        let newItems = [];
        for (let i = 0; i < 8; i++) {
          newItems.push({
            name: "设备" + i.toString(),
            title: "设备" + i.toString(),
            status: "false"
          });
        }
        return newItems
      },
      errorTitle() {
        if (!this.errormessage) {
          return "";
        }

        const result = this.errormessage.match(this.errorTitleReg)
        return result ? result[0] : "";
      },
      errorContent() {
        if (!this.errormessage) {
          return "";
        }
        return this.errormessage.replace(this.errorTitleReg, "");
      },
      errorTitleReg() {
        return /^(【退回】|【更址】|【待派】|【弃件】)/
      }
    },
    data() {
      return {
        deviceStateLabelVisible: true,
        deviceItems: [],
        // deviceItems: [],
      };
    },
    methods: {
      getInputFocus(e) {
        e.currentTarget.select();
        this.$emit("inputFocus", e);
        console.log("CurrentDeviceType:"+SystemConfigModule.globalData.CurrentDeviceType);
        if (
          SystemConfigModule.globalData.CurrentDeviceType == 2 ||
          SystemConfigModule.globalData.CurrentDeviceType == 7 ||
          SystemConfigModule.globalData.CurrentDeviceType == 8
        ) {
          try {
            obj_GlobalData_Core.changeToEnglish(true);
            console.log("切换到英文");
          } catch (error) {
            console.log(error);
          }
        }
      },
      lostInputFocus(e){
        if (
          SystemConfigModule.globalData.CurrentDeviceType == 2 ||
          SystemConfigModule.globalData.CurrentDeviceType == 7 ||
          SystemConfigModule.globalData.CurrentDeviceType == 8
        ) {
          try {
            obj_GlobalData_Core.changeToEnglish(false);
            console.log("切换到中文");
          } catch (error) {
            console.log(error);
          }
        }
      },
      checkFontSize() {
        if (/\s*\d层/.test(this.errormessage)) {
          return true;
        }
        return false;
      },
      input_ScanArea_Click(e) {
        e.target.select();
        this.$emit("getCode", e);
        this._value = "";
      },
      setFocus() {
        this.$refs.code.focus();
      },
      selectInput() {
        this.$refs.code.select();
      },
      size2() {
        var size2 = (getStrLen(this.errormessage) > 32 && getStrLen(this.errormessage) <= 40);
        console.log(size2)
        return size2;
      },
      size3() {
        var size3 = getStrLen(this.errormessage) > 40;
        console.log(size3)
        return size3;
      }
    }
  };
</script>

<style lang="less">
  @import "scan.less";

  .scan-box-card > .el-card__body {
    padding-top: 0px;
    padding-bottom: 0px;
    height: 100%;
  }

  .errormsgdiv.size2 {
    font-size: 20pt;
  }

  .errormsgdiv.size3 {
    font-size: 15pt;
  }

  .scan-box-card > .el-card__body > div {
    height: 100%;
  }

  .scan-label .el-form-item__label {
    color: @primaryColor;
  }

  .labelpadding .scan-label {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .labelpadding .scan-label .el-form-item__content {
    width: 80%;
  }

  @media only screen and (min-width: 990px) and (max-width: 1200px) {
    .scanarea-style .el-input__inner{
      font-size: 20pt;
    }
  }
</style>
<style scoped lang="less">
  .scan-div {
    border: 1px @primaryBorderColor solid;

    > .el-card {
      border: none;
    }
  }

  .labelpadding {
    padding: 0px 5px 0px 5px;
    /* padding-top: 0px; */
  }

  .errorlabelpadding {
    padding-top: 0px;
  }


  .devicestate-style {
    margin-top: 10px;
    text-align: right;
    padding: 15px 10px;
  }

  .scanarea-style {
  }


  .el-form-item-scanarea {
    display: inline;
  }

  .el-form-scanarea {
    height: 100%;

    .scan-label {
      height: 100%;
    }

    /*margin-top: 10px;*/

    /*position: relative;*/
    /*top: 50%;*/
    /*transform: translateY(-50%);*/

    /deep/ .el-form-item {
      margin-bottom: 0px;
    }
  }

  .el-form-scanarea /deep/ .el-form-item__label {
    /* font-size: 1.370rem; */
    font-size: 1.30rem;
  }

  .errormsgdiv.oversize {
    font-size: 50pt;
  }

  @media only screen and (max-width: 767px) {
    .scanarea-style {
      //width: 65%;
    }
  }

  @media only screen and (min-width: 768px) and (max-width: 991px) {
    .scanarea-style {
      //width: 75%;
    }
  }

  @media only screen and (min-width: 990px) and (max-width: 1200px) {
    .scanarea-style {
      //width: 80%;
    }
    .scanarea-style .el-input__inner{
      font-size: 20pt;
    }

    .el-form-scanarea {
      margin-top: 0px;
    }

    .device_div {
      /*margin-top: -10px;*/
    }
  }

  .scan-box-card {
    /* height: 125px; */
    background: @cardBackColor;
    height: 135px;
  }

  /* el-divider 修改高度&虚线效果 */
  .el-divider--horizontal {
    margin: 6px 0;
    background: 0 0;
    border-top: 40px dashed #e8eaec;
  }

  @media only screen and (max-height: 769px) and (min-height: 728px) {
    .package_img {
      height: 100px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  @media only screen and (min-height: 769px) {
    .package_img {
      height: 100px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  @media only screen and (max-height: 720px) {
    .package_img {
      height: 100px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }

</style>
